export default __webpack_public_path__ + "static/media/settings.697716f4.svg";